import { OpenInNew } from '@mui/icons-material';
import { SxProps, Typography } from '@mui/material';
import React, { CSSProperties } from 'react';

import { LinkDiv } from '../theme/CustomComponents';

interface LearnMoreProps {
  link: string;
  text?: string;
  sx?: SxProps;
  iconSx?: SxProps;
  color?: CSSProperties['color'];
}

const LearnMore = ({
  link,
  sx,
  iconSx,
  color = '#070154',
  text = 'Learn More',
}: LearnMoreProps) => (
  <LinkDiv style={{ color, width: 'fit-content' }}>
    <Typography
      variant="caption1"
      sx={{ ...sx, color }}
      onClick={() => {
        window.open(link, '_blank');
      }}
    >
      {text}
    </Typography>
    <OpenInNew
      sx={{ fontSize: '12px', verticalAlign: 'middle', ...(iconSx || {}), color }}
      onClick={() => {
        window.open(link, '_blank');
      }}
    />
  </LinkDiv>
);

export default LearnMore;
